import React, { useEffect, useState } from "react";
import AlertDialog from "../components/AlertDialog";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useSelector, useDispatch } from "react-redux";
import { Typography, TextField, Button, Grid, Box, InputAdornment } from "@mui/material";
import { api } from "common";
import { useTranslation } from "react-i18next";
import { useNavigate,useLocation } from "react-router-dom";
import CircularLoading from "components/CircularLoading";
import { useParams } from "react-router-dom";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import LocalTaxiOutlinedIcon from "@mui/icons-material/LocalTaxiOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import PercentOutlinedIcon from "@mui/icons-material/PercentOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { getLangKey } from "common/src/other/getLangKey";
import { resolveCurrencySymbol } from "common/src/other/currencyFormat";
import {
  C2_FONT,
  c2TextFieldSx,
  c2PrimaryBtnSx,
  c2SecondaryBtnSx,
} from "../components/conecta2ModalStyles";
import { C2, C2Switch } from "../components/Table/C2UserTable";
import FormSection, { c2RtlFieldSx as rtlFieldSx } from "../components/C2FormSection";

const EditCarType = () => {
    const { t, i18n } = useTranslation();
    const { id} = useParams();
    const isRTL = i18n.dir();
    const settings = useSelector((state) => state.settingsdata.settings);
    const cartypes = useSelector((state) => state.cartypes);
    const carlistdata = useSelector((state) => state.carlistdata);
    const staticusers = useSelector((state) => state.usersdata.staticusers);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loding, setLoding] = useState(false);
    const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
    const { editCarType, updateUserCar, editCar, convertLanguage } = api;
    const [oldData, setOldData] = useState(null);
    const [data, setData] = useState(null);
    const {state}=useLocation()
    const auth = useSelector((state) => state.auth);
  
    useEffect(() => {
      if ( id){
          if( cartypes && cartypes.cars) {
        const carData = cartypes.cars.filter(
          (item) => item.id === id.toString()
        )[0];
        if (!carData) {
          navigate("/404");
        }
        setData(carData);
        setOldData(carData);
      }
      } else{
        setData({
            name: "",
            base_fare: 0,
            convenience_fee_type: "",
            pos: "",
            convenience_fees: 0,
            rate_per_hour: 0,
            extra_info: "",
            min_fare: 0,
            rate_per_unit_distance: 0,
            fleet_admin_fee: 0,
            image: "https://cdn.pixabay.com/photo/2012/04/15/22/09/car-35502__480.png",
            visibleInApp: true,
            womenOnly: false,
        })
      }
    }, [cartypes,cartypes.cars, id, navigate]);
  
    const handleInputChange = (e) => {
      setData({ ...data, [e.target.id]: e.target.value });
    };
  
    const handleInputToNumberChange = (e) => {
      setData({ ...data, [e.target.id]: Number(e.target.value) });
    };
  
    const handleExtraInfoChange = (e) => {
      setData({ ...data, extra_info: e.target.value });
    };
  
    const handleCommonAlertClose = (e) => {
      e.preventDefault();
      setCommonAlert({ open: false, msg: "" });
    };
    const handleSubmit = () => {

        if(! id) {
            if (
                !(
                  data &&
                  data.name &&
                  data.pos &&
                  data.convenience_fee_type &&
                  data.base_fare &&
                  data.min_fare &&
                  data.rate_per_hour &&
                  data.rate_per_unit_distance
                )
              ) {
                if (!(data && data.name)) {
                  setCommonAlert({ open: true, msg: t("proper_input_name") });
                } else if (!data.pos) {
                  setCommonAlert({ open: true, msg: t("position_required") });
                } else if (!data.base_fare) {
                  setCommonAlert({ open: true, msg: t("base_fare_required") });
                } else if (!data.min_fare) {
                  setCommonAlert({ open: true, msg: t("min_fare_required") });
                } else if (!data.rate_per_hour) {
                  setCommonAlert({ open: true, msg: t("rate_per_hour_required") });
                } else if (!data.rate_per_unit_distance) {
                  setCommonAlert({
                    open: true,
                    msg: t("rate_per_unit_distance_required"),
                  });
                } else if (!data.convenience_fee_type) {
                  setCommonAlert({ open: true, msg: t("convenience_fee_type_required") });
                }
              } else {
                settings.AllowCriticalEditsAdmin
                  ? new Promise((resolve, reject) => {
                    setLoding(true);
                    setTimeout(async() => {
                      if (data && data.name) {
                        data["createdAt"] = new Date().getTime();
                        await convertLanguage(data.name, auth?.profile?.lang?.langLocale ? auth.profile.lang.langLocale : null);
                        dispatch(editCarType(data, "Add"));
                        resolve();
                        setLoding(false);
                        navigate("/cartypes");
                      } else {
                        setCommonAlert({ open: true, msg: t("proper_input_name") });
                        reject(new Error("Enter proper name"));
                        setLoding(false);
                      }
                    }, 600);
                  })
                  : new Promise((resolve) => {
                    setTimeout(() => {
                      resolve();
                      setCommonAlert({ open: true, msg: t("demo_mode") });
                    }, 600);
                  });
              }
        }

        else if(id){
          if (
              !(
                data &&
                data.name &&
                data.pos &&
                data.convenience_fee_type &&
                data.base_fare &&
                data.min_fare &&
                data.rate_per_hour &&
                data.rate_per_unit_distance
              )
            ) {
              if (!(data && data.name)) {
                setCommonAlert({ open: true, msg: t("proper_input_name") });
              } else if (!data.pos) {
                setCommonAlert({ open: true, msg: t("position_required") });
              } else if (!data.base_fare) {
                setCommonAlert({ open: true, msg: t("base_fare_required") });
              } else if (!data.min_fare) {
                setCommonAlert({ open: true, msg: t("min_fare_required") });
              } else if (!data.rate_per_hour) {
                setCommonAlert({ open: true, msg: t("rate_per_hour_required") });
              } else if (!data.rate_per_unit_distance) {
                setCommonAlert({
                  open: true,
                  msg: t("rate_per_unit_distance_required"),
                });
              } else if (!data.convenience_fee_type) {
                setCommonAlert({ open: true, msg: t("convenience_fee_type_required") });
              }
            } else {
              settings.AllowCriticalEditsAdmin
              ? new Promise((resolve) => {
                setLoding(true);
                setTimeout(async() => {
                  resolve();
                  if (data !== oldData) {
                    delete data.tableData;
                    if (data.name !== oldData.name && staticusers) {
                      let users =staticusers && staticusers.filter(
                        (user) =>
                          user.usertype === "driver" && user.carType === oldData.name
                      );
                      for (let i = 0; i < users?.length; i++) {
                        dispatch(
                          updateUserCar(users[i].id, {
                            carType: data.name,
                          })
                        );
                      }
                      let cars = carlistdata.cars.filter(
                        (car) => car.carType === oldData.name
                      );
                      for (let i = 0; i < cars.length; i++) {
                        dispatch(
                          editCar({ ...cars[i], carType: data.name }, "Update")
                        );
                      }
                    }
                    await convertLanguage(data.name, auth?.profile?.lang?.langLocale ? auth.profile.lang.langLocale : null);
                    dispatch(editCarType(data, "Update"));
                    navigate("/cartypes",{state:{pageNo:state?.pageNo}});
                    setLoding(false);
                  }else{
                    setLoding(false); 
                    setCommonAlert({ open: true, msg: t("make_changes_to_update") });
                  }
                }, 600);
              })
              : new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  alert(t("demo_mode"));
                }, 600);
              });
          }
        }
    };
  
    const handleChangeConvenienceFeeType = (e) => {
      setData({ ...data, convenience_fee_type: e.target.value });
    };

  const goBack = () => navigate("/cartypes",{state:{pageNo:state?.pageNo}});
  const dir = isRTL === "rtl" ? "rtl" : "ltr";
  const fieldSx = isRTL === "rtl" ? { ...c2TextFieldSx, ...rtlFieldSx } : c2TextFieldSx;
  const currency = resolveCurrencySymbol(settings || { country: "Colombia", code: "COP" });
  const moneyAdornment = {
    startAdornment: (
      <InputAdornment position="start">
        <Typography sx={{ fontFamily: C2_FONT, fontWeight: 700, color: C2.muted, fontSize: "0.9rem" }}>
          {currency}
        </Typography>
      </InputAdornment>
    ),
  };
  const percentAdornment = {
    endAdornment: (
      <InputAdornment position="end">
        <Typography sx={{ fontFamily: C2_FONT, fontWeight: 700, color: C2.muted }}>%</Typography>
      </InputAdornment>
    ),
  };
  const serviceFeeAdornment =
    data?.convenience_fee_type === "percentage" ? percentAdornment : moneyAdornment;
  const displayName = data?.name ? t(getLangKey(data.name)) : "";
  const previewImage = id && data?.image ? data.image : null;

  const numberField = (fieldId, label, extra = {}) => (
    <TextField
      label={label}
      id={fieldId}
      value={data?.[fieldId] || 0}
      type="number"
      fullWidth
      onChange={handleInputToNumberChange}
      sx={fieldSx}
      {...extra}
    />
  );

  return loding ? (
    <CircularLoading />
  ) : (
    <Box sx={{ direction: dir }}>
      <Box
        sx={{
          backgroundColor: C2.white,
          border: `1px solid ${C2.border}`,
          borderRadius: "18px",
          boxShadow: "0 8px 24px rgba(26,15,59,0.06)",
          p: { xs: 2, sm: 3 },
          maxWidth: 1100,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 2,
            mb: 3,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, minWidth: 0 }}>
            <Box
              sx={{
                width: 72,
                height: 56,
                borderRadius: "14px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                p: previewImage ? 0.75 : 0,
                backgroundColor: previewImage ? C2.lavender : "transparent",
                border: previewImage ? `1px solid ${C2.border}` : "none",
                background: previewImage ? undefined : `linear-gradient(135deg, ${C2.violet}, ${C2.bright})`,
                boxShadow: previewImage ? "none" : "0 6px 16px rgba(100,17,237,0.28)",
              }}
            >
              {previewImage ? (
                <img alt="CarType" src={previewImage} style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
              ) : (
                <LocalTaxiOutlinedIcon sx={{ color: C2.white, fontSize: 30 }} />
              )}
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{
                  fontFamily: C2_FONT,
                  fontWeight: 800,
                  fontSize: { xs: "1.15rem", sm: "1.35rem" },
                  color: C2.sidebar,
                  lineHeight: 1.2,
                }}
              >
                {id ? t("update_carType_title") : t("add_carType_title")}
              </Typography>
              <Typography sx={{ fontFamily: C2_FONT, fontSize: "0.88rem", color: C2.muted, mt: 0.25 }}>
                {id && displayName
                  ? `Editando: ${displayName}`
                  : "Define el nombre, las tarifas y las comisiones del nuevo servicio."}
              </Typography>
            </Box>
          </Box>
          <Button
            variant="outlined"
            startIcon={<ArrowBackRoundedIcon sx={{ transform: isRTL === "rtl" ? "scaleX(-1)" : "none" }} />}
            onClick={goBack}
            sx={c2SecondaryBtnSx}
          >
            {t("go_back")}
          </Button>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
          <FormSection
            icon={InfoOutlinedIcon}
            title="Información general"
            subtitle="Cómo se muestra el servicio en la app."
          >
            <Grid item xs={12} md={6}>
              <TextField
                label={t("name")}
                id="name"
                value={data?.name || ""}
                fullWidth
                onChange={handleInputChange}
                sx={fieldSx}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              {numberField("pos", t("position"), {
                helperText: "Orden en que aparece en la lista de vehículos.",
                FormHelperTextProps: { sx: { fontFamily: C2_FONT, color: C2.muted } },
              })}
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label={t("extra_info")}
                id="extra_info"
                value={data?.extra_info || ""}
                fullWidth
                onChange={handleExtraInfoChange}
                sx={fieldSx}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  height: "100%",
                  minHeight: 56,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 1.5,
                  px: 2,
                  borderRadius: "12px",
                  border: `1px solid ${C2.border}`,
                  backgroundColor: C2.white,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, minWidth: 0 }}>
                  <VisibilityOutlinedIcon sx={{ color: data?.visibleInApp !== false ? C2.violet : C2.muted, fontSize: 22 }} />
                  <Box sx={{ minWidth: 0 }}>
                    <Typography sx={{ fontFamily: C2_FONT, fontWeight: 700, fontSize: "0.9rem", color: C2.sidebar }}>
                      {t("visible_in_app")}
                    </Typography>
                    <Typography sx={{ fontFamily: C2_FONT, fontSize: "0.78rem", color: C2.muted }}>
                      {data?.visibleInApp !== false
                        ? "Los usuarios pueden elegir este servicio."
                        : "Oculto para los usuarios."}
                    </Typography>
                  </Box>
                </Box>
                <C2Switch
                  checked={data?.visibleInApp !== false}
                  onChange={(e) => setData({ ...data, visibleInApp: e.target.checked })}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  height: "100%",
                  minHeight: 56,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 1.5,
                  px: 2,
                  borderRadius: "12px",
                  border: `1px solid ${C2.border}`,
                  backgroundColor: data?.womenOnly ? "#FDF2F8" : C2.white,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, minWidth: 0 }}>
                  <Box sx={{ minWidth: 0 }}>
                    <Typography sx={{ fontFamily: C2_FONT, fontWeight: 700, fontSize: "0.9rem", color: C2.sidebar }}>
                      {t("women_only_service") || "C2 Púrpura / Solo mujeres"}
                    </Typography>
                    <Typography sx={{ fontFamily: C2_FONT, fontSize: "0.78rem", color: C2.muted }}>
                      {data?.womenOnly
                        ? "Solo pasajeras y conductoras (gender = female)."
                        : "Servicio abierto a todos los usuarios."}
                    </Typography>
                  </Box>
                </Box>
                <C2Switch
                  checked={!!data?.womenOnly}
                  onChange={(e) => setData({ ...data, womenOnly: e.target.checked })}
                />
              </Box>
            </Grid>
          </FormSection>

          <FormSection
            icon={PaymentsOutlinedIcon}
            title="Tarifas"
            subtitle="Valores que se usan para calcular el precio del viaje."
          >
            <Grid item xs={12} sm={6} lg={3}>
              {numberField("base_fare", t("base_fare"), { InputProps: moneyAdornment })}
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              {numberField("min_fare", t("min_fare"), { InputProps: moneyAdornment })}
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              {numberField("min_fare_distance", t("min_fare_distance") || "Km en mínima", {
                helperText: "Km cubiertos por la mínima (ej. 2.5 en Barranquilla). Vacío = piso clásico.",
              })}
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              {numberField("rate_per_unit_distance", t("rate_per_unit_distance"), { InputProps: moneyAdornment })}
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              {numberField("rate_per_hour", t("rate_per_hour") || "Tarifa por minuto (T)", {
                InputProps: moneyAdornment,
                helperText: "Tiempo (T) en minutos. Ej.: 150 = $150 por cada minuto de viaje.",
              })}
            </Grid>
          </FormSection>

          <FormSection
            icon={PercentOutlinedIcon}
            title="Comisiones"
            subtitle="Tarifa de servicio de Conecta2 y comisión para administradores de flota."
          >
            <Grid item xs={12} md={4}>
              <FormControl fullWidth sx={fieldSx}>
                <InputLabel id="convenience-fee-type-label">{t("convenience_fee_type")}</InputLabel>
                <Select
                  labelId="convenience-fee-type-label"
                  id="convenience_fee_type"
                  value={data?.convenience_fee_type || ""}
                  label={t("convenience_fee_type")}
                  onChange={handleChangeConvenienceFeeType}
                  sx={{ fontFamily: C2_FONT, color: C2.sidebar }}
                >
                  <MenuItem sx={{ fontFamily: C2_FONT, direction: dir }} value={"flat"}>
                    {t("flat")}
                  </MenuItem>
                  <MenuItem sx={{ fontFamily: C2_FONT, direction: dir }} value={"percentage"}>
                    {t("percentage")}
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              {numberField("convenience_fees", t("convenience_fee"), { InputProps: serviceFeeAdornment })}
            </Grid>
            <Grid item xs={12} md={4}>
              {numberField("fleet_admin_fee", t("fleet_admin_fee"), {
                InputProps: percentAdornment,
                inputProps: { min: 0, max: 100 },
                helperText: "Porcentaje sobre el valor del viaje menos la tarifa de servicio.",
                FormHelperTextProps: { sx: { fontFamily: C2_FONT, color: C2.muted } },
              })}
            </Grid>
          </FormSection>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            flexWrap: "wrap",
            gap: 1.5,
            mt: 3,
            pt: 2.5,
            borderTop: `1px solid ${C2.lavender}`,
          }}
        >
          <Button variant="outlined" onClick={goBack} sx={{ ...c2SecondaryBtnSx, minWidth: 140 }}>
            {t("cancel")}
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            sx={{ ...c2PrimaryBtnSx, minWidth: 200, py: 1.25, fontSize: "1rem" }}
          >
            {id ? t("update") : t("submit")}
          </Button>
        </Box>
      </Box>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
    </Box>
  );
};

export default EditCarType
